import { Injectable } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { CookieService } from 'ngx-cookie-service';
import { ACCESS_TOKEN_KEY } from './auth.service';

export const LOGGEDIN_MARKER_KEY = 'LOGGED_IN';

@Injectable({
  providedIn: 'root',
})
export class SsoCustomStorageService extends OAuthStorage {
  constructor(private cookieService: CookieService) {
    super();
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === LOGGEDIN_MARKER_KEY) {
        // Another Browser-Tab removed the magic entry in localStorage (he logged out)
        // so we remove our tokens as well
        sessionStorage.clear();
        localStorage.clear();
      }
    });
  }

  getItem(key: string): string {
    return sessionStorage.getItem(key);
  }
  removeItem(key: string): void {
    //this.cookieService.delete(key);
    sessionStorage.removeItem(key);
    if (key == ACCESS_TOKEN_KEY) {
      this.cookieService.delete(ACCESS_TOKEN_KEY);
      // User has logged out on this Browser-Tab
      // Remove the magic entry on localStorage to tell other Browser-Tabs that they should
      // clear their session storage
      localStorage.removeItem(LOGGEDIN_MARKER_KEY);
      localStorage.clear();
    }
  }

  setItem(key: string, data: string): void {
    //debugger;
    if (key == ACCESS_TOKEN_KEY) {
      this.cookieService.set(ACCESS_TOKEN_KEY, data, null, '/');
      // User has logged in on this Browser-Tab
      // Set the magic entry that, when removed, fires events on other Browser-Tabs
      localStorage.setItem(LOGGEDIN_MARKER_KEY, 'true');
    }
    //delete if old jwt cookie exists
    const oldCookie = this.cookieService.get('jwtCookie');
    if (oldCookie) {
      this.cookieService.delete('jwtCookie');
    }
    //this.cookieService.set(key, data,null,null,null,false);
    sessionStorage.setItem(key, data);
  }
}
